// wxPay/WxPayRefundOrderEditBase.tsx
import { Col, DatePicker, Form, Input, InputNumber, Row, Select, Switch } from 'antd';
import { useEffect, useRef, useState } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import getList from '../../../utilsTsx/universal/getList';

export interface WxPayRefundOrderEditBaseConfig {
    /** 业务 apiId，例如 'wxPayRefundOrder' / 'wxPayRefundOrderBak' */
    apiId: string;
    /** 透传的外部 props（原函数组件 props） */
    outerProps: any;
}

const WxPayRefundOrderEditBase = (config: WxPayRefundOrderEditBaseConfig) => {
    const { apiId, outerProps } = config;
    const { defaultService } = outerProps;

    const [form] = Form.useForm();
    const ref = useRef<any>(undefined);
    const [refundStatusData, setRefundStatusData] = useState<any>();

    useEffect(() => {
        fetchApi.GET(defaultService, {
            query: {
                apiId: 'generalData',
                apiVariable: 'refundStatus',
                apiExtend: 'showLists'
            }
        }).then(res => {
            if (res.success) {
                const { refundStatus } = res.data;
                setRefundStatusData(refundStatus);
            }
        });
    }, []);

    let extendProps: WebEditUniversalProps = {
        ...outerProps,
        apiId,                               // ← 变量替换硬编码
        serviceId: 'pay',
        dateOptions: {
            columnNames: ['refundTime']
        },
        displayOptions: {
            width: 900
        },
        formOptions: {
            instance: form,
            children: (
                <Row gutter={[8, 0]}>
                    <Col span={6}>
                        <Form.Item label="id" name="id">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={7}>
                        <Form.Item label="支付订单" name="payOrderId">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={5}>
                        <Form.Item
                            label="退款金额"
                            name="refundAmount"
                            rules={[{ required: true, message: '请输入退款金额!' }]}>
                            <InputNumber />
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item label="退款状态" name="refundStatusId">
                            <Select
                                showSearch
                                placeholder="退款状态"
                                optionFilterProp="children"
                                filterOption={(input, option: any) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                {getList.general(refundStatusData)}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={10}>
                        <Form.Item label="退款id" name="wxPayRefundId">
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item label="退款时间" name="refundTime">
                            <DatePicker format="YYYY-MM-DD HH:mm:ss" />
                        </Form.Item>
                    </Col>

                    <Col span={3}>
                        <Form.Item
                            label="成功"
                            name="isRefund"
                            valuePropName="checked"
                            initialValue={false}>
                            <Switch checked={false} checkedChildren="是" unCheckedChildren="否" />
                        </Form.Item>
                    </Col>

                    <Col span={3}>
                        <Form.Item
                            label="状态"
                            name="isUse"
                            valuePropName="checked"
                            initialValue={true}>
                            <Switch checked={true} checkedChildren="启用" unCheckedChildren="关闭" />
                        </Form.Item>
                    </Col>
                </Row>
            )
        }
    };

    return <WebEditUniversal ref={ref} {...extendProps} />;
};

export default WxPayRefundOrderEditBase;